// --- React Configuration
import React from 'react';
import { createRoot } from 'react-dom/client';
// --- Redux Configuration
import { Provider } from 'react-redux';
import store from 'shared/redux/store';
// --- Application Core
import { Core } from './Core';
// --- Global Styles
import 'shared/assets/styles/_base.scss';

/**
 * Entry point for the React application.
 *
 * This file is responsible for rendering the main application component
 * and providing the Redux store to the application.
 * It also includes global styles for the application.
 *
 * @module
 * @returns {void}
 */
const rootElement = document.getElementById('root');

// Check if the root element exists before rendering
if (rootElement) {
    // Create a root for the React application
    const root = createRoot(rootElement);

    // Render the Core component wrapped in the Redux Provider
    root.render(
        <Provider store={store}>
            <Core />
        </Provider>,
    );
} else {
    console.error('Root element not found!');
}
